// extracted by mini-css-extract-plugin
export default {"action":"H0pYyI","info":"Smn6XV","icon":"luWIyF","share-icon":"MLirin","shareIcon":"MLirin"};